import createAction from 'utils/createAction';

import { CLOSE_DIALOG, OPEN_DIALOG } from './constants';

export const openDialog = createAction(OPEN_DIALOG);
export const closeDialog = createAction(CLOSE_DIALOG);
